/* eslint-disable class-methods-use-this */
import _bundle from '../../../../core/core--bundles';

export default function() {
    function savePrevValue(settings, type) {
        const { $elFormItem, $elActual } = settings;
        const status = $elFormItem.data('status');
        // Cache value for all elments except checkbox
        if ($elActual.data(type)) {
            $elFormItem.data('prevValue', $elActual.data(type).value());
        } else if ($elActual.data().type === type) {
            $elFormItem.data('prevValue', $elActual.prop('checked'));
        }
        // Cache status
        if (status) $elFormItem.data('prevIsUserDefault', JSON.parse(status.isUserDefault));
    }

    function getNewValue(el, type) {
        // Checkbox exception
        if (type === 'YesNo') {
            return el.prop('checked');
        }
        // The rest of form items
        return el.data(type) ? el.data(type).value() : null;
    }

    function cachePreviousValues(settings) {
        savePrevValue(settings, 'kendoDropDownList');
        savePrevValue(settings, 'kendoAutoComplete');
        savePrevValue(settings, 'kendoDatePicker');
        savePrevValue(settings, 'YesNo');
        // Debug the Data
        // const { $elFormItem } = settings;
        // const dataDebug = $.map($elFormItem, el => ({
        //     prevValue: $(el).data().prevValue,
        //     prevIsUserDefault: $(el).data().prevIsUserDefault
        // }));
        // console.log(dataDebug[0]);
    }

    function indicatorsInitialState({ $elFormItem, $elWidget, $elActual }) {
        const { status } = $elFormItem.data();
        const { isUserDefault: statusString } = status;
        const isUserDefault = JSON.parse(statusString);
        if (isUserDefault) {
            $elFormItem.addClass('form-item--user-defaults');
        } else {
            $elFormItem.removeClass('form-item--user-defaults');
        }
    }

    function indicatorsChangeState({ $elFormItem, $elWidget, $elActual }) {
        $elActual.change(e => {
            // Any change
            // $elFormItem.addClass('form-item--changed');

            // Current item Change based on the data
            const $el = $(e.target);
            const { prevValue, prevIsUserDefault } = $elFormItem.data();
            let newValue = false;
            newValue =
                getNewValue($el, 'kendoDropDownList') ||
                getNewValue($el, 'kendoAutoComplete') ||
                getNewValue($el, 'kendoDatePicker') ||
                getNewValue($el, 'YesNo');

            // Apply changes to only fields that were save as defaults
            if (prevIsUserDefault) {
                if (newValue !== prevValue) {
                    $elFormItem.addClass('form-item--changed');
                } else {
                    $elFormItem.removeClass('form-item--changed');
                }
            }
        });
    }

    _bundle.add({
        name: 'Form Indicators',
        event: ['on:PageUpdate'],
        fn() {
            const $el = $('#paramPane .form-item');
            if ($el.length) {
                $el.each(function(i, el) {
                    const $elFormItem = $(this);
                    const $elWidget = $elFormItem.find('.k-widget');
                    let $elActual;
                    // Kendo MVC spits out two input tags for a checbox. So we need the first one
                    if ($elFormItem.find('input').is(':checkbox')) {
                        $elActual = $elFormItem.find('input').first();
                    } else {
                        // The rest of form elements
                        $elActual = $elFormItem.find('input');
                    }
                    const settings = {
                        $elFormItem,
                        $elWidget,
                        $elActual
                    };
                    indicatorsInitialState(settings);
                    cachePreviousValues(settings);
                    indicatorsChangeState(settings);
                });
            }
        }
    });
}
